/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloProvider } from '@apollo/client';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import * as dotenv from 'dotenv';
import React from 'react';
import ReactDOM from 'react-dom';
import Theme from 'Theme';
import client from './apollo/client';
import App from './App';
import './index.css';
dotenv.config();

ReactDOM.render(
    <ApolloProvider client={client}>
        <ApolloHooksProvider client={client as any}>
            <Theme>
            <App />
            </Theme>
        </ApolloHooksProvider>
    </ApolloProvider>,
    document.getElementById('root'),
);
